import { useEffect, useState } from 'react';
import { cn } from '../lib/cn';

interface AIToastProps {
  message: string;
  onClose: () => void;
}

export default function AIToast({ message, onClose }: AIToastProps) {
  const [displayedText, setDisplayedText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isDoneTyping, setIsDoneTyping] = useState(false);

  useEffect(() => {
    if (currentIndex < message.length) {
      const timeout = setTimeout(() => {
        setDisplayedText(prev => prev + message[currentIndex]);
        setCurrentIndex(prev => prev + 1);
      }, 30); // 30ms per character for fast typing

      return () => clearTimeout(timeout);
    } else if (!isDoneTyping) {
      setIsDoneTyping(true);
    }
  }, [currentIndex, message, isDoneTyping]);

  return (
    <>
      {/* Toast message */}
      <div
        className={cn(
          'fixed left-1/2 z-50',
          'px-4 py-3 rounded-lg shadow-lg',
          'w-[calc(100%-2rem)] max-w-md',
          'bg-gradient-to-br from-pink-400 to-rose-400 text-white',
          'opacity-95',
          'cursor-pointer',
          'transition-all duration-200',
          'max-h-[200px] overflow-y-auto'
        )}
        style={{ 
          top: 'calc(50% + 100px)', // Позиция ниже игрового поля, текст растёт вниз
          transform: 'translateX(-50%)' // Центрирование
        }}
        onClick={onClose}
      >
        <div className="flex items-start gap-3">
          {/* AI Icon */}
          <div className="flex-shrink-0 mt-0.5">
            <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
            </svg>
          </div>
          
          {/* Typing text */}
          <div className="text-sm font-medium flex-1 break-words">
            {displayedText}
            {currentIndex < message.length && (
              <span className="inline-block w-0.5 h-4 bg-white ml-0.5 animate-pulse" />
            )}
          </div>
        </div>
        
        {/* Hint to close */}
        {isDoneTyping && (
          <p className="text-xs text-white/70 mt-2 text-center">
            Нажмите для закрытия
          </p>
        )}
      </div>
    </>
  );
}

